import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Route } from 'react-router-dom';

import reqwest from 'reqwest';
import settings from '../../../../settings';

import Loader from '../../../components/Loader';

import Basedata from './tabs/Basedata/index';

class Benutzerverwaltung extends Component {
  constructor(props) {
    super(props);

    this.userid = props.match.params.userId;

    this.state = {
      loading: true,
      formData: {},
    };
  }

  componentDidMount() {
    if (this.userid) {
      reqwest({
        method: 'get',
        url: settings.usermanagement.general.get,
        data: {
          Token: localStorage.getItem('token'),
          Usernr: this.userid,
        },
      }).then(res => {
        res = JSON.parse(res);
        this.setState({
          formData: res,
          guid: res[0].Params.Guid,
          loading: false,
        });
      });
    }
  }

  render() {
    if (this.state.loading) return <Loader />;
    return (
      <div className='FormArea'>
        <div className='FormArea-Top'>
          <p className='FormArea-Title'>
            #{this.state.formData[0]?.Params.Expnr} {this.state.formData[0]?.Params.Firstname} {this.state.formData[0]?.Params.Lastname}
          </p>
        </div>
        <div className='FormArea-Body'>
          <div className='FormArea-Body-Content'>
            <div className='FormArea-Body-Content-Center'>
              <div className='FormArea-Form'>
                <Route render={() => <Basedata UserGuid={this.state.guid} />} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Benutzerverwaltung.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      userId: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default Benutzerverwaltung;
